/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetOrganizationUserSessionIssuerSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetOrganizationUserSessionIssuerRequest = {
  /**
   * The user_session_issuer id.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetOrganizationUserSessionIssuerSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetOrganizationUserSessionIssuerSecurity$outboundSchema:
  z.ZodMiniType<
    GetOrganizationUserSessionIssuerSecurity$Outbound,
    GetOrganizationUserSessionIssuerSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function getOrganizationUserSessionIssuerSecurityToJSON(
  getOrganizationUserSessionIssuerSecurity:
    GetOrganizationUserSessionIssuerSecurity,
): string {
  return JSON.stringify(
    GetOrganizationUserSessionIssuerSecurity$outboundSchema.parse(
      getOrganizationUserSessionIssuerSecurity,
    ),
  );
}

/** @internal */
export type GetOrganizationUserSessionIssuerRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetOrganizationUserSessionIssuerRequest$outboundSchema:
  z.ZodMiniType<
    GetOrganizationUserSessionIssuerRequest$Outbound,
    GetOrganizationUserSessionIssuerRequest
  > = z.pipe(
    z.object({
      id: z.string(),
      gramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
      });
    }),
  );

export function getOrganizationUserSessionIssuerRequestToJSON(
  getOrganizationUserSessionIssuerRequest:
    GetOrganizationUserSessionIssuerRequest,
): string {
  return JSON.stringify(
    GetOrganizationUserSessionIssuerRequest$outboundSchema.parse(
      getOrganizationUserSessionIssuerRequest,
    ),
  );
}
